<!--pro-item-->
<div class="pro-item main" *ngFor="let extraItem of extraItemInfo?.data">
   
<!-- Button trigger modal -->
    <a href="javascript:void(0);" class="pro-item-img" title="{{extraItem.extraItemTitle}}">
        <img [src]="[serverImgUrl] + '/extraImages/' + [extraItem.extraItemImageURL] || '../../assets/images/all/1.jpg'"
            alt="{{extraItem.extraItemTitle}}" (click)="onClick($event, extraItem.extraItemTitle)" data-bs-toggle="modal" data-bs-target="#myModal">
    </a>
    <div class="pro-item-det">
        <div class="pro-item-det-header fl-wrap">
            <h4>{{extraItem.extraItemTitle}}</h4>
        </div>
        <p>{{extraItem.extraItemDetails}}</p>
    </div>
</div>
<!--pro-item end-->

<div class="alert alert-danger p-2 mb-0" *ngIf="!extraItemInfo?.data"> No extra product/service added.</div>

<!-- Modal -->
<div class="modal fade" style="margin-top:5%; background-color: rgba(0, 0, 0, 0.5);" id="myModal" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false" >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5"> {{modalTitle}}</h1>
          <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
        </div>
        <div class="modal-body">
        <img
        src="{{modalImg}}"
        alt="{{modalTitle}}"
        loading="lazy"
        decoding="async"
        style="max-width:100%; width:405px; cursor:pointer"/> 
        </div>
      </div>
    </div>
</div>
